module.exports = __webpack_public_path__ + "static/index/img/baikal-800.c8234c16.jpg";